let maxScrollDepth = 0.0;
/**
 * Measures the current percentage scrolled through the article text.
 * Returns a value between 0.0 and 1.0, or undefined in case of error.
 * Also updates the maxScrollDepth, returned by maxArticleScrollDepth()
 *
 * Could actually be used to measure scroll depth on non-article pages too,
 * but for the first known use-case it's just on articles.
 */
export function articleScrollDepth(contentSelector) {
    const articleElement = document.querySelector(contentSelector);
    if (articleElement == undefined) {
        return undefined;
    }
    const viewPositionY = window.innerHeight + window.scrollY;
    const articleBottomAbs = window.scrollY + articleElement.getBoundingClientRect().bottom;
    // This also takes care of divide-by-zero possibilities
    if (articleBottomAbs <= viewPositionY) {
        maxScrollDepth = 1.0;
        return 1.0;
    }
    const readDepthPercent = viewPositionY / articleBottomAbs;
    if (readDepthPercent > maxScrollDepth) {
        maxScrollDepth = readDepthPercent;
    }
    return readDepthPercent;
}
/**
 * Returns the maximum article scroll depth seen.
 * (eg. in case a user scrolls to bottom, then back up, this will still report 1.0)
 *
 * Note that if there was never any scrolling by the viewer, then this will be reported
 * as 0.0 (the initial value).
 */
export function maxArticleScrollDepth() {
    return maxScrollDepth;
}
/**
 * Function that sets up the event handler required for scroll depth tracking.
 */
export function initialiseScrollDepthTracking(contentSelector = "div.content-body") {
    if (document.querySelector(contentSelector) == undefined) {
        logWarningOutsideOfProd("Element not found -- cannot calculate scroll depth.");
        return;
    }
    maxScrollDepth = 0.0;
    document.addEventListener("scroll", () => articleScrollDepth(contentSelector));
}
function logWarningOutsideOfProd(message) {
    if (window.location.host.includes("theconversation.com")) {
        return;
    }
    console.warn(message);
}
